import React from "react";
import {withRouter} from "react-router-dom";
import Validator from "validator";
import PropTypes from "prop-types";

import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import AuthLayout from "../../shared/containers/AuthLayout";
import {InputFieldGroup} from "../../shared/components/InputFieldGroup";
import {getRelatives, has, inviteRelative} from "./actions/relativesAction";
import {getSeniors} from "./actions/seniorsAction";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from "../../shared/modules/notification/constants";
import {filter} from "../../shared/actions";
import {ROUTER_MEMBERS} from "../../shared/constants/routers";
import {ANALYTICS_SPECS} from "../../shared/constants";
import {sendAnalyticsEvent} from "../../shared/actions/analytics";


class InviteContainer extends React.Component {

  static propTypes = {
    email: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    errors: PropTypes.object,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    email: "",
    firstname: "",
    lastname: "",
    errors: {},
    isLoading: false
  };

  state = {
    email: "",
    firstname: "",
    lastname: "",
    errors: {},
    isLoading: false
  };

  onSubmit = (evt) => {
    evt.preventDefault();
    this.setState({errors: {}, isLoading: true});

    const relative = filter(
      this.state,
      [
        "email",
        "firstname",
        "lastname"
      ]
    );
    const {errors, isValid} = this.validateInput(relative);

    if (isValid) {
      sendAnalyticsEvent(ANALYTICS_SPECS.MEMBERS.NAME, ANALYTICS_SPECS.MEMBERS.EVENTS.SEND_INVITE);
      this.props.dispatch(inviteRelative({
        ...relative,
        prof_id: this.props.location.state.senior.prof_id
      }))
        .then(() => {
          this.props.dispatch(
            notificationAction.addNotification(
              __("The invitation has been sent successfully."),
              NOTIFICATION_SUCCESS
            )
          );
          this.props.history.goBack();
        })
        .catch(() => {
          this.props.dispatch(
            notificationAction.addNotification(
              __("Something went wrong, try it again later."),
              NOTIFICATION_ERROR
            )
          );
          this.setState({isLoading: false});
        });
    } else {
      this.setState({errors: errors, isLoading: false});
    }
  };

  validateInput(data) {
    let isValid = true;
    const errors = {};

    if (Validator.isEmpty(data.email)) {
      errors.email = __("Please enter an e-mail address.");
      isValid = false;
    } else if (!Validator.isEmail(data.email)) {
      errors.email = __("This email address is invalid.");
      isValid = false;
    } else if (this.props.dispatch(has({email: data.email}))) {
      errors.email = __("This e-mail address is already being used by one person in your family portal.");
      isValid = false;
    }

    return {
      errors,
      isValid: isValid
    }
  }

  componentDidMount() {
    if (typeof this.props.location.state !== "undefined" &&
      "senior" in this.props.location.state
    ) {
      this.props.dispatch(getSeniors())
        .then((seniors) => {
          this.props.dispatch(getRelatives(seniors))
        });
    } else {
      this.props.history.push(ROUTER_MEMBERS);
    }

    sendAnalyticsEvent(ANALYTICS_SPECS.MEMBERS.NAME, ANALYTICS_SPECS.MEMBERS.EVENTS.OPEN_INVITE_CONTACT_SCREEN);
  }

  onChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  };

  render() {
    const {errors, email, firstname, lastname, isLoading} = this.state;

    return (
      <AuthLayout title={__("Invite people")}
                  onBackLink={this.props.history.goBack}>
        <div id="invite">
          <div className="hintBox">
            Sende per Email eine Einladung zum Familienportal:
          </div>
          <form className="" onSubmit={this.onSubmit}>
            <InputFieldGroup
              name="firstname"
              type="text"
              value={firstname}
              onChange={this.onChange}
              error={errors.firstname}
              placeholder={__("Firstname")}
            />
            <InputFieldGroup
              name="lastname"
              type="text"
              value={lastname}
              onChange={this.onChange}
              error={errors.lastname}
              placeholder={__("Lastname")}
            />
            <InputFieldGroup
              name="email"
              type="email"
              value={email}
              onChange={this.onChange}
              error={errors.email}
              placeholder={__("E-Mail")}
            />
            <button className="buttonPrimary" disabled={isLoading}>
              {__("Send invitation")}
            </button>
          </form>
        </div>
      </AuthLayout>
    );
  }
}

export default withRouter(InviteContainer);
